import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import sourceReducer from './Slice/SourceSlice'
import destinationReducer from './Slice/DestinationSlice'

const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({
  source: sourceReducer,
  destination: destinationReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
})

export const persistor = persistStore(store)
